import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../src/components/AuthContextComponent";
import ManualUpload from "../src/pages/manualupload/index";
import Login from "../src/pages/login/index";
import Reports from "../src/pages/reports";
import { ROUTES } from "./lib/enums/index";
import Layout from "../src/components/LayoutComponent";
import PatchNotes from "./pages/patchnotes/PatchNotes";
import Track from "./pages/track";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { environment } from "./lib/config/Config";
import Approve from "./pages/approve";
import Profile from "./pages/profile/Profile";
import Reprocess from "./pages/reports/reprocess";
import InboxNotification from "./components/InboxNotificationComponent";

const RouterConfig = () => {
  const { loggedIn, userInfo, approverStatus } = useContext(AuthContext);

  // Disable React DevTools in production
  if (environment === "production") {
    disableReactDevTools();
  }
  const commonRoutes = (
    <>
      <Route path={ROUTES.REPORTS} element={<Reports />} />
      <Route path={ROUTES.PATCHNOTE} element={<PatchNotes />} />
      <Route path={ROUTES.PROFILESECTION} element={<Profile />} />
      <Route path={ROUTES.PROFILE} element={<Profile />} />
      <Route path={ROUTES.APPROVE} element={<Approve />} />
      <Route path={ROUTES.REPROCESS} element={<Reprocess />} />
      <Route path={ROUTES.INBOXNOTIFICATION} element={<InboxNotification />} />
    </>
  );
  return (
    <BrowserRouter>
      {loggedIn ? (
        <Layout>
          <Routes>
            {userInfo?.isUploader && (
              <Route path={ROUTES.MANUALUPLOAD} element={<ManualUpload />} />
            )}
            {commonRoutes}
            {approverStatus ? (
              <Route path={ROUTES.TRACK} element={<Track />} />
            ) : null}
          </Routes>
        </Layout>
      ) : (
        <Routes>
          <Route path={ROUTES.LOGIN} element={<Login />} />
        </Routes>
      )}
    </BrowserRouter>
  );
};

export default RouterConfig;
